import * as React from 'react';
import { LocalizationService } from './LocalizationService';
export var LocalizationContext = React.createContext(new LocalizationService('en'));
//# sourceMappingURL=LocalizationContext.js.map